import { render, staticRenderFns } from "./NDialog2.vue?vue&type=template&id=d2530632"
import script from "./NDialog2.vue?vue&type=script&lang=js"
export * from "./NDialog2.vue?vue&type=script&lang=js"
import style0 from "./NDialog2.vue?vue&type=style&index=0&id=d2530632&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports